'use client';

import {SubmitExperienceModal} from 'iq-interview_experiences/components/submit_experience_modal';
import {trackSubmitExperienceOpened} from 'iq-interview_experiences/tracking';
import {InterviewGuideData} from 'iq-interview_guides/types';
import {useState} from 'react';

export default function SubmitExperienceBanner({
  data,
  variant = 'sidebar',
}: {
  data: InterviewGuideData;
  variant?: 'sidebar' | 'inline';
}) {
  const [modalOpen, setModalOpen] = useState(false);

  function handleClick() {
    void trackSubmitExperienceOpened('banner');
    setModalOpen(true);
  }

  return (
    <>
      {variant === 'inline' ? (
        <div className='bg-white border border-iq-grey-light rounded-xl p-4 flex flex-row items-center justify-between gap-4'>
          <div>
            <p className='font-bold text-sm leading-snug text-iq-black'>Had an interview recently?</p>
            <p className='text-iq-grey-medium text-xs mt-1'>
              Share your experience. Unlock the full guide.
            </p>
          </div>
          <button
            onClick={handleClick}
            className='shrink-0 bg-iq-red text-white text-xs font-semibold px-3 py-2 rounded-lg hover:opacity-90 transition-opacity text-center'>
            Share my experience
          </button>
        </div>
      ) : (
        /* Submit experience banner */
        <div className='bg-white border border-iq-grey-light rounded-xl p-4 flex flex-col gap-3'>
          <div>
            <p className='font-bold text-sm leading-snug text-iq-black'>Had an interview recently?</p>
            <p className='text-iq-grey-medium text-xs mt-1'>
              Share your experience. Unlock the full guide.
            </p>
          </div>
          <button
            onClick={handleClick}
            className='bg-iq-red text-white text-xs font-semibold px-3 py-2 rounded-lg hover:opacity-90 transition-opacity text-center'>
            Share my experience
          </button>
        </div>
      )}

      {modalOpen && (
        <SubmitExperienceModal
          onClose={() => setModalOpen(false)}
          guideSlug={data.slug}
          defaultCompanySlug={data.company_slug}
          defaultPositionSlug={data.position_slug}
          companyId={data.company_id}
          positionId={data.position_id}
        />
      )}
    </>
  );
}
